import { all, call, fork, put, takeLatest, } from 'redux-saga/effects';
import moment from 'moment';
import axios from 'axios';
import qs from 'qs';
import actions from '../actions/setting_data';
import loginActions from '../actions/login';
import adminActions from '../actions/admin';
import rf from '../../requests/RequestFactory';
import { FETCH_CRYPTO_LIMIT_WITHDRAWAL_SUCCEED, } from '../actions/setting_data/action_types';
import { BASE_URL } from '../../consts';

// saga effect

function* fetchAuthIfNeed() {
  const strSession = window.localStorage.getItem('session');
  const session = JSON.parse(strSession || '{}');
  // check token expired
  if (!!session && moment(session.time_expired / 1000).isAfter()) {
    // add token for axios
    yield put(loginActions.loginNormalSucceed(session));
    window.axios = axios.create({
      baseURL: BASE_URL,
      headers: {
        token: session.token,
      },
      paramsSerializer(params) {
        return qs.stringify(params);
      },
    });
    // yield put(adminActions.fetchAdminBalancesAction());
    yield put(adminActions.fetchOwnBalance());
    yield put(adminActions.onFetchAuthInfo());
  }
}

function* saveMasterData() {
  const masterData = JSON.parse(localStorage.getItem('CRYPTO'));
  yield put(actions.fetchAllCoinActionSucceed(masterData.coins));
  yield put(actions.fetchCoinSettingActionSucceed(masterData.settings));
  yield put({
    type: FETCH_CRYPTO_LIMIT_WITHDRAWAL_SUCCEED,
    data: masterData.withdrawal_limits,
  });
}

function* fetchSettingIfNeed() {
  try {
    if (localStorage.getItem('CRYPTO_HASH')) {
      const cryptoHash = yield call(() => rf.getRequest('SettingRequest').fetchSettingHash());

      const hash = localStorage.getItem('CRYPTO_HASH');
      if (hash === cryptoHash.data) {
        yield saveMasterData();
        return;
      }
    }

    const { data, hash } = yield call(() => rf.getRequest('SettingRequest').fetchCryptoSetting());
    yield localStorage.setItem('CRYPTO', JSON.stringify(data));
    yield localStorage.setItem('CRYPTO_HASH', hash);

    yield saveMasterData();

  } catch (err) {
    console.log('err');
  }
}

function* fetchInit() {
  try {
    console.log('== @fetchInit ==');

    // yield utils.resetCacheTimeTVChart();
    yield fetchAuthIfNeed();
    yield fetchSettingIfNeed();
    const markets = yield call(() => rf.getRequest('SettingRequest').fetchMarkets());
    // TODO change follow user
    yield put(actions.fetchMarketActionSucceed(markets?.data));
    yield put({type:"@@__INIT__SUCCEED"})
    // const session = yield select((state) => state.user.session);
    // yield put(actions.fetchLimitWithdrawalAction({ pubkey: session.pubkey }));
    // yield put(adminActions.fetchLimitWithdrawalOfAdminAction({ pubkey: session.pubkey }));

    // const markets = yield call(() => rf.getRequest('SettingRequest').fetchMarkets());
    // TODO change follow user
    // yield put(actions.fetchMarketActionSucceed(markets.data));
  } catch (err) {
    console.log(err, 'err');
  }
}

// function* postCoin(action) {
//   try {
//     yield rf.getRequest('SettingRequest').postCoinSetting(action.params.data);
//   } catch (err) {
//     console.log(err, 'err');
//   }
// }

function* watchInit() {
  yield takeLatest('@@__INIT__', fetchInit);
  // yield takeLatest(POST_COIN_SETTING, postCoin);
}

export default function* rootSaga() {
  yield all([fork(watchInit)]);
}
